import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  applicationOverviewTitle: {
    id: "funding-application: application overview title",
    defaultMessage: "Application overview",
    description:
      "Title of a page where customer sees a summary of what they will need to perform during their application process",
  },
  applicationOverviewDescription: {
    id: "funding-application: application overview description",
    defaultMessage: "Complete the following steps to submit your application for funding.",
  },
  applicationOverviewConnectPlatforms: {
    id: "funding-application: application overview connect platforms",
    defaultMessage: "Connect platforms",
  },
  applicationOverviewUploadDocuments: {
    id: "funding-application: application overview upload documents",
    defaultMessage: "Upload documents",
  },
  applicationOverviewAllBankAccounts: {
    id: "funding-application: application overview all bank accounts",
    defaultMessage: "All bank accounts",
    description: "Appears as an item in a list of things to connect in order to finish the application process",
  },
  applicationOverviewNoActionRequired: {
    id: "funding-application: application overview no action required title",
    defaultMessage: "No action required",
    description:
      "Title of a section that lists connections we can't connect and process - and that's why there is no action required from the customer",
  },
  applicationOverviewNoActionRequiredDescription: {
    id: "funding-application: application overview no action required description",
    defaultMessage:
      "The data from this platform is not required. We’ll use other data sources you connect to review your application. ",
  },
  applicationOverviewAllBankAccountsLabel: {
    id: "funding-application: application overview all bank accounts label",
    defaultMessage: "All bank accounts",
  },
  documentUploadSusa: {
    id: "funding-application: SUSA document name",
    defaultMessage: "SUSA",
  },
  documentUploadPoolBancario: {
    id: "funding-application: Pool Bancario document name",
    defaultMessage: "Pool Bancario",
  },
  documentUploadAccounting: {
    id: "funding-application: management accounts document name",
    defaultMessage: "Management accounts",
  },
  documentUploadProfitAndLoss: {
    id: "funding-application: profit and loss document name",
    defaultMessage: "Profit and Loss Statement",
  },
  documentUploadBalanceSheet: {
    id: "funding-application: balance sheet document name",
    defaultMessage: "Balance Sheet",
  },
  documentUploadRevenueForecast: {
    id: "funding-application: revenue cash flow forecast document name",
    defaultMessage: "Revenue/Cash flow forecast",
  },
  documentUploadDebtAgreement: {
    id: "funding-application: debt agreement document name",
    defaultMessage: "Debt agreements",
  },
  documentUploadPurchaseOrder: {
    id: "funding-application: purchase orders document name",
    defaultMessage: "Purchase orders",
  },
  connectPlatformsTitle: {
    id: "funding-application: connect platforms title",
    defaultMessage: "Connect platforms",
    description:
      "Title of a page where customer sees a summary of what they will need to perform to complete their application process",
  },
  connectPlatformsDescription: {
    id: "funding-application: connect platforms description",
    defaultMessage:
      "To continue your financing application, please connect your bank account(s). Once that’s done, you can choose to add the platforms you use to run your business — like Stripe, QuickBooks or Shopify.",
  },
  connectPlatformsRequired: {
    id: "funding-application: connect platforms required",
    defaultMessage: "Required",
  },
  connectPlatformsGetStarted: {
    id: "funding-application: connect platforms get started",
    defaultMessage: "Get started",
  },
});
